// Genera una huella digital del dispositivo combinando múltiples características
// No es 100% infalible pero es muy difícil de falsificar

export async function getDeviceFingerprint() {
  const components = [];

  // v2: componentes estables (no cambian con las actualizaciones del navegador)
  // 1. Familia de sistema operativo (sin versiones)
  const ua = navigator.userAgent || '';
  const osFamily = /Android/i.test(ua) ? 'android' : /iPhone|iPad|iPod/i.test(ua) ? 'ios' : /Windows/i.test(ua) ? 'windows' : /Mac OS X|Macintosh/i.test(ua) ? 'mac' : /Linux/i.test(ua) ? 'linux' : 'other';
  components.push(osFamily);
  components.push(navigator.platform || '');

  // 2. Zona horaria
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone || '');

  // 3. Pantalla (lado mayor y menor: no cambia al rotar el celular)
  components.push(`${Math.max(screen.width, screen.height)}x${Math.min(screen.width, screen.height)}x${screen.colorDepth}`);
  components.push(String(window.devicePixelRatio || 1));

  // 4. Hardware
  components.push(String(navigator.hardwareConcurrency || 0));
  components.push(String(navigator.deviceMemory || 0));

  // 5. Touch (celular vs PC)
  components.push(String(navigator.maxTouchPoints || 0));

  // 6. Canvas fingerprint — cómo el GPU renderiza
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Gestion360🔐', 2, 15);
    ctx.fillStyle = 'rgba(102,204,0,0.7)';
    ctx.fillText('Gestion360🔐', 4, 17);
    components.push(canvas.toDataURL());
  } catch (e) {
    components.push('canvas_error');
  }

  // 7. WebGL fingerprint
  try {
    const gl = document.createElement('canvas').getContext('webgl');
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        components.push(gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || '');
        components.push(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '');
      }
    }
  } catch (e) {
    components.push('webgl_error');
  }

  // Hash de todos los componentes
  const str = components.join('|||');
  const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  const hashArray = Array.from(new Uint8Array(hash));
  return 'v2:' + hashArray.map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 32);
}
